import React from "react";
import "./proposalStepGuide.css";
import ProposalForm from "../Form/proposalForm";
import ISPReferenceBanner from "../common/ispReferenceBanner";

export const ProposalStepGuide = ({
  editProposal,
  formProposalType,
  formRequestType,
  lists,
  loggedIn,
  insertType,
  updateLastUpdateDate,
  lastUpdateDate,
  checkForUpdates,
  dataLoading,
  navigateToFusion,
  ispReferenceClients,
  ispReferenceAmount,
  ispReferenceGoal,
  ispReferenceFusionAllocations,
  dismissISPReferenceBanner,
}) => {
  // Block the UI until all required data is loaded
  if (dataLoading) {
    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 50px)",
            position: "fixed",
            width: "100vw",
            backgroundColor: "#A2AAB6",
          }}
        />
        <div className="container">
          <div style={{ paddingTop: "35px" }}>
            <div className="card">
              <div className="card-body">
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p style={{ marginTop: "20px" }}>
                    Loading proposal data, please wait...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          height: "calc(100vh - 50px)",
          position: "fixed",
          width: "100vw",
          backgroundColor: "#A2AAB6",
        }}
      />
      <div className="container">
        <div style={{ paddingTop: "35px" }}>
          <div className="card">
            <div className="card-body">
              <ISPReferenceBanner
                clients={ispReferenceClients}
                amount={ispReferenceAmount}
                goal={ispReferenceGoal}
                fusionAllocations={ispReferenceFusionAllocations}
                onDismiss={dismissISPReferenceBanner}
              />
              <ProposalForm
                lists={lists}
                updateLastUpdateDate={updateLastUpdateDate}
                lastUpdateDate={lastUpdateDate}
                checkForUpdates={checkForUpdates}
                insertType={insertType}
                formProposalType={formProposalType}
                editProposal={editProposal}
                formRequestType={formRequestType}
                loggedIn={loggedIn}
                navigateToFusion={navigateToFusion}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
